document.addEventListener('DOMContentLoaded', function() {
    // Your code here
    
});